export default __webpack_public_path__ + "static/media/CNo.64-4.fda7c488.jpg";